import DOMPurify from "dompurify";

export default function HtmlContent({ html, className = "" }) {
  if (!html) return null;
  const safeHtml = DOMPurify.sanitize(html);
  return (
    <div
      className={`prose max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
